// ============================================================
// NBS KURSNA LISTA — srednji kurs preko Supabase funkcije "nbs-rate"
// (izvor: kurs.resenje.org, koji preuzima zvanične podatke NBS)
// ============================================================
import { supabase } from './supabase';

// Kurs jedne valute; date (YYYY-MM-DD) je opcion — bez njega današnji kurs
export async function fetchNbsRate(currencyCode, date) {
  const { data, error } = await supabase.functions.invoke('nbs-rate', {
    body: { currency: currencyCode, ...(date ? { date } : {}) },
  });
  if (error || !data || !data.rate) {
    throw new Error('Ne mogu da preuzmem kurs sa NBS. Pokušajte ponovo za minut.');
  }
  return { rate: data.rate, date: data.date };
}

// Kursevi više valuta odjednom za izabrani dan → { EUR: { rate, date } | null, ... }
export async function fetchNbsRates(currencies, date) {
  const { data, error } = await supabase.functions.invoke('nbs-rate', {
    body: { currencies, ...(date ? { date } : {}) },
  });
  if (error || !data || !data.rates) throw new Error('Ne mogu da preuzmem kursnu listu sa NBS.');
  return data.rates;
}
